import React from 'react';
import { useUIContext } from '../../context/UIContext';
import Content from '../Content/Content';
import styles from './StoryboardEditor.module.scss';
import cx from 'classnames';
import NewStoryboardCreator from '../NewStoryboardCreator/NewStoryboardCreator';
import { PROJECT_STATE } from '../../constants/projectCreatorConsts';
import PreparingStoryProcessing from '../PreparingStoryProcessing/PreparingStoryProcessing';
import GeneratedScenesEditor from '../GeneratedScenesEditor/GeneratedScenesEditor';
import { LoaderContent } from '../LoaderContent/LoaderContent';

const StoryboardEditor = ({
  init,
  video,
  projectState,

  selectedOrientation,
  changeProjectOrientation,

  skipGeneration,
  generateNarratives,
  skipGenerateNarratives,

  applyAssistantChanges,
  pushJobs,
}) => {
  const { miniSidebar } = useUIContext();

  if (!init || skipGeneration) {
    return <LoaderContent />;
  }

  return (
    <Content className={cx(styles.editContent, { [styles.miniSidebar]: miniSidebar })}>
      {projectState === PROJECT_STATE.FILL_THE_FORM && (
        <NewStoryboardCreator
          selectedOrientation={selectedOrientation}
          generateNarratives={generateNarratives}
          skipGenerateNarratives={skipGenerateNarratives}
          changeOrientation={changeProjectOrientation}
        />
      )}
      {(projectState === PROJECT_STATE.GENERATING_NARRATIVES || projectState === PROJECT_STATE.GENERATING_SCRIPT) && (
        <PreparingStoryProcessing state={projectState} hideText={skipGeneration} />
      )}
      {projectState === PROJECT_STATE.NARRATIVES_EDITING && (
        <GeneratedScenesEditor
          videoAuthor={video?.author}
          applyAssistantChanges={applyAssistantChanges}
          pushJobs={pushJobs}
        />
      )}
    </Content>
  );
};

export default StoryboardEditor;
